export interface SalesInvoiceCreditNotes {
  documentDate: Date;
  invoiceMonthNumber: number;
  invoiceMonthName: string;
  weekNo: number;
  year: number;
  documentNo: number;
  documentType: string;
  customerInvoiceRef: string;
  crmNo: string;
  onInvoiceNo: number;
  creditNoteReason: string;
  invoiceCountryName: string;
  despatchNoteNo: number;
  despatchDate: Date;
  deliveryCountryName: string;
  orderNo: string;
  customerOrderRef: string;
  orderDate: Date;
  orderTypeDescription: string;
  customerAccount: string;
  customerName: string;
  vatRegNo: string;
  customerCountryName: string;
  agent: string;
  agentName: string;
  customerOrderNo: string;
  contractNo: number;
  productType: string;
  productKey: string;
  oldCode: string;
  productDescription: string;
  stockNo: string;
  tariffCode: string;
  productGroup: string;
  colour: string;
  makeUp: string;
  customerLineRef: string;
  noOfItems: number;
  lotNo: string;
  grossQuantity: number;
  nettQuantity: number;
  freeOfChargeQuantity: number;
  uom: string;
  nettSqMts: number;
  conversionQuantity: number;
  cuom: string;
  width: number;
  salesDiscount: number;
  invCrtPrice: number;
  currencyCode: string;
  discount: number;
  discountAmount: number;
  currencyValue: number;
  rate: number;
  sterlingValue: number;
  taxCode: string;
  taxRate: number;
  taxValue: number;
  total: number;
  sterlingTotal: number;
  costPrice: number;
  costValue: number;
  margin: number;
  marginPercentage: number;
  nominalAccount: string;
  nominalDescription: string;
  shipper: string;
  shippingService: string;
  trackingNo: string;
  paymentTerms: string;
  paymentDueDate: Date;
  deliveryTerms: string;
  settlementTerms: string;
  modeOfTransport: string;
  orderSource: string;
  invCrtStatus: string;
  sellingCompany: string;
  port: string;
  enteredBy: string;
  deliveryAddress: string;
  exportOrder: string;
}
